import type { Notification } from '../types/notification.types';

/**
 * Formatea el nombre del rol para mostrarlo de manera amigable
 * @param roleName - Nombre del rol con guiones bajos
 * @returns Nombre formateado con espacios y capitalizado
 */
export const formatRoleName = (roleName: string): string => {
  return roleName
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Obtiene el color del borde según el estado de la notificación
 * @param statusId - ID del estado de la notificación
 * @returns Clases CSS para el color del borde
 */
export const getBorderColor = (statusId: number): string => {
  switch (statusId) {
    case 1:
      return 'border-l-4 border-red-500';
    case 2:
      return 'border-l-4 border-green-500';
    case 3:
      return 'border-l-4 border-gray-400';
    default:
      return 'border-l-4 border-muted';
  }
};

/**
 * Formatea la fecha de creación de la notificación
 * @param dateString - Fecha en formato string
 * @returns Objeto con fecha y hora formateadas
 */
export const formatNotificationDate = (dateString: string) => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const formattedTime = date.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
  });
  
  return { formattedDate, formattedTime };
};

/**
 * Determina si el usuario puede mostrar el botón de cerrar
 * @param userRole - Rol del usuario actual
 * @param originUserRole - Rol de origen de la notificación
 * @returns Boolean indicando si puede cerrar
 */
export const canShowCloseButton = (userRole: string, originUserRole: string): boolean => {
  return (
    userRole === "admin" ||
    userRole === originUserRole ||
    (originUserRole === "observatorio_observador" && userRole === "observatorio_editor")
  );
};

/**
 * Determina si el usuario puede mostrar el botón de responder
 * @param userRole - Rol del usuario actual
 * @param targetUserRole - Rol de destino de la notificación
 * @returns Boolean indicando si puede responder
 */
export const canShowResponderButton = (userRole: string, targetUserRole: string): boolean => {
  return (
    userRole === "admin" ||
    userRole === targetUserRole ||
    (targetUserRole === "observatorio_observador" && userRole === "observatorio_editor")
  );
}; 